import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=f08e9c0c&"
import script from "./Publish.vue?vue&type=script&lang=ts&"
export * from "./Publish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports